module.exports = __webpack_public_path__ + "static/media/circle-background.a617e630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/top-home-search/circle-background.png
// module id = 2256
// module chunks = 0